<template>
  <div class="page-project-overlay-info">
    <WidgetButtonCtaIco
      class="page-project-overlay-info__trigger"
      :buttonType="'expand'"
      :label="$t('cta.projectDetails')"
      @click="open()"
    />

    <WidgetOverlayFromBottom :show="openOverlay" @close="close">
      <template v-slot:content>
        <PagesProjectDescription :project="project" />
      </template>
    </WidgetOverlayFromBottom>
  </div>
</template>

<script>
export default {
  name: 'PagesProjectDescription',
}
</script>

<script setup>
const props = defineProps({
  project: Object,
})

const openOverlay = ref(false)

const open = () => {
  openOverlay.value = true
}

const close = () => {
  openOverlay.value = false
}
</script>

<style lang="scss">
@import './style.scss';
</style>
